import { FC, Suspense } from "react";
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from "react-router-dom";
import { useDynamicRouting } from "shared/hooks/useDynamicRouting";
import { SIGN_IN_PATH } from "shared/routes/paths";
import { useAuth } from "../entities/auth/hooks/useAuth";
import SignIn from "../modules/signIn/pages/SignIn";
import { generateRoutes } from "./helpers";
import AppLoader from "./layouts/AppLoader";
import MainLayout from "./layouts/MainLayout";

const App: FC = () => {
  useAuth();
  const { dynamicRoutes, isLoadingRoutes, freeToPlayMainPageId } =
    useDynamicRouting();

  if (isLoadingRoutes) {
    return <AppLoader />;
  }

  const router = createBrowserRouter([
    {
      path: "/",
      element: <MainLayout />,
      children: [
        {
          path: "brands/free/pages",
          element: (
            <Navigate
              to={`/brands/free/pages/${freeToPlayMainPageId}`}
              replace
            />
          ),
        },
        ...generateRoutes(Object.values(dynamicRoutes)),
      ],
    },
    {
      path: SIGN_IN_PATH,
      element: <SignIn />,
    },
  ]);

  return (
    <Suspense>
      <RouterProvider router={router} />
    </Suspense>
  );
};

export default App;
